export const headerSection = {
  benefits: 'Beneficis',
  partners: 'Socis',
  setups: 'Configuracions',
};
export const description = `El sol és la nostra principal font d'energia i de vida a la Terra. Els combustibles fòssils es van crear al seu dia a partir de la seva energia, però ara els estem consumint tan ràpid que aviat ens quedarem sense ells. L' explotació de l' energia solar és el primer pas cap a la conscienciació mediambiental. I ens complau poder acompanyar-lo en aquest viatge.`